module.exports = __webpack_public_path__ + "static/media/sorigin_logo.41335162.png";